
<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="comision"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmarComision" title="Confirmar Acción"
                 appendTo="body"></p-confirmDialog>
<div class="p-grid" style="width: 99%">
  <div class="p-col-12">
    <app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
                     [botonRegresar]="btnRegresar" [barraBotonesCRUD]="false"
                     [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true" [barraBotones5]="true"
                     (signal)="manejarSenales($event)"></app-invmaebarra>
  </div>
  <div style="overflow: hidden" class="p-col-12">
    <p-tabView>
      <p-tabPanel header="Comisión">
        <app-aggridsaci [width]=""
                        [height]="largo"
                        [enableSorting]="false"
                        [enableFilter]="true"
                        [rowData]="comisionService.comisionesServicio"
                        [frameworkComponents]="frameworkComponents"
                        [animateRows]="true"
                        [rowSelection]="rowSelection"
                        [columnDefs]="columnDefsCxccomision"
                        [defaultColDef]="defaultColDefCxccomision"
                        [rowStyle]="rowStyle"
                        [singleClickEdit]="false"
                        [botones]="false"
						(guardarEnter)="controlGuardar($event)"
						(selected)="seleccionComision($event)"
                        (cambios)="cambio($event)"

        ></app-aggridsaci>
      </p-tabPanel>
    </p-tabView>
  </div>


</div>
